import {
    Component, OnInit, Input, EventEmitter, HostListener,
    ElementRef, ViewContainerRef
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouterModule, Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


import { SharedData } from '../shared/sharedData';

import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import * as _ from 'underscore';
import { Auth } from '../shared/services/auth';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ToolsMenu',
    templateUrl: 'mgrLevelList.html',
    outputs: ['updateRate: hideMe']
})

export class ManagerLevelComponent {
    public updateRate: any = new EventEmitter();
    public pageSize: any = 10;
    public page = 1;
    public startingPage: any = 1;
    public endingPage: any = 10;
    public collectionSize: any;
    public _baseUrl: any;
    public trackHides = null;
    public mgrdata: any = [];
    public mgrPageData: any = [];
    public showLoading: any = false;

    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public router: Router,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _auth: Auth,
        public eRef: ElementRef,
        public share: SharedData,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public _toaster: ToasterComponent,
        public vcr: ViewContainerRef) {

        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getAllDesignation();

    }

    // pagination functions
    public onPageChange(event: number): void {
        let that = this;
        if (event === 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        } else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            } else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getAllDesignation();
    }
    public OnPageSizeChanged(val) {
        this.pageSize = val;
        this.getAllDesignation();
    }

    public addDesignation() {
        this.share.saveData({ mgrId: null, type: 'ADD' });
        this.router.navigate(['menu/addMgrLevel']);
    }

    public editDesignation(val) {
        this.share.saveData({ mgrdata: val, type: 'EDIT' });
        this.router.navigate(['menu/addMgrLevel']);
    }
    public deleteDesg(val) {
        this.share.saveData({ mgrdata: val, type: 'DELETE' });
        this.router.navigate(['menu/addMgrLevel']);
    }

    public getAllDesignation() {
        let self = this;
        self.showLoading = true;
        let url = self._baseUrl + 'v1/webAdmin/managerLevel';
        self.http.post(url, { page: self.page, pageSize: self.pageSize }).subscribe((result) => {
            self.mgrdata = result.content;
            self.mgrPageData = result;
            if (self.mgrdata.length === 0) {
                self.showLoading = false;
            }
            self.collectionSize = result.totalElements;
            if (result.last) {
                self.endingPage = self.collectionSize;
            }
        }, (error) => {
            self.showLoading = false;
            console.log('getAllmgrdata error catch', error);
        });
    }

    public empActions(val) {
        // this.hide = val;
    }
    public empTableActions(value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        } else {
            this.trackHides = value;
        }

    }

    @HostListener('window:click', ['$event'])
    public clickOut(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(() => {
                this.trackHides = null;
            }, 100);
        }
    }
    public clicked() {
        this.trackHides = null;
    }

    public onRefresh(){
        this.getAllDesignation();
    }
}



// WEBPACK FOOTER //
// ./src/app/tools/mgrLevelList.ts